module.exports = __webpack_public_path__ + "img/rec_edges_r_t.a88b10fd.png";